import { Button } from '@material-ui/core';
import styled from '../../styled';

export const SecondaryCtaButton = styled<typeof Button, { target: string }>(
  Button
)`
  border: 0;
  color: #000;
  height: 48px;
  padding: 0 30px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  font-weight: 700;
  position: relative;
  transition: all 0.2s ease-in-out;
  transform: scale(1);

  &:disabled {
    color: white;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

export const CtaButton = styled<
  typeof Button,
  { target?: string; size?: 'small' | 'medium' | 'large' }
>(Button)`
  background-color: #0e1c2b;
  color: white;
  height: ${(p) =>
    p.size === 'small' ? '40px' : p.size === 'medium' ? '48px' : '56px'};
  padding: 0
    ${(p) =>
      p.size === 'small' ? '24px' : p.size === 'medium' ? '32px' : '40px'};
  font-weight: 700;
  font-size: ${(p) =>
    p.size === 'small' ? '14px' : p.size === 'medium' ? '16px' : '18px'};
  text-transform: none;
  border-radius: 100px;
  box-shadow: none;

  &:hover {
    background-color: #1f3348;
  }
`;
